"use strict";

exports.__esModule = true;
exports.RealtimeMetricChartElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Metrics = require("../../../Catalogs/Metrics");
var _API = require("../../API");
var _Charts = require("../../Charts");
var _getNonWidgetProps = require("../../ConfigurableLayout/common/getNonWidgetProps");
var _Core = require("../../Core");
var _DeviceContext = require("../../Device/DeviceContext");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _Metrics2 = require("../../Metrics");
var _Time = require("../../Time");
var _MetricChartContextMenu = require("./MetricChartContextMenu");
var _excluded = ["metricChartSeries", "devices", "device", "width", "height", "hideXAxis", "hideYAxis", "hideLabel", "dataRange", "reportingPeriod", "selection"];
var _dec, _dec2, _dec3, _dec4, _class, _RealtimeMetricChartElement;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays a chart for a particular metric.
 */
var RealtimeMetricChartElement = exports.RealtimeMetricChartElement = (_dec = _Core.SelectionContext.withContext, _dec2 = _Time.ReportingPeriodContext.withContext, _dec3 = _DeviceContext.DeviceContext.withContext, _dec4 = _DeviceListContext.DeviceListContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (_RealtimeMetricChartElement = /*#__PURE__*/function (_Component) {
  function RealtimeMetricChartElement() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(RealtimeMetricChartElement, _Component);
  var _proto = RealtimeMetricChartElement.prototype;
  _proto.getMetricNames = function getMetricNames() {
    var metricChartSeries = this.props.metricChartSeries;
    return metricChartSeries.map(function (series) {
      return series.metricName;
    });
  };
  _proto.getDevices = function getDevices() {
    var _this$props = this.props,
      device = _this$props.device,
      devices = _this$props.devices;
    if (device) {
      return [device];
    }
    return devices || [];
  };
  _proto.getMetricChannels = function getMetricChannels() {
    var _this = this;
    return this.getDevices().reduce(function (channels, device) {
      return Object.assign(channels, _this.getDeviceMetricChannels(device));
    }, {});
  };
  _proto.getDeviceMetricChannels = function getDeviceMetricChannels(device) {
    var reportingPeriod = this.props.reportingPeriod;
    var channels = {};
    for (var _iterator = _createForOfIteratorHelperLoose(this.getMetricNames()), _step; !(_step = _iterator()).done;) {
      var metricName = _step.value;
      var metric = (0, _Metrics.getMetricDefinition)(metricName);
      channels[device.uuid + ":" + metricName] = ["metric", {
        entity: {
          device: device.uuid,
          name: metric.name,
          period: reportingPeriod && reportingPeriod.name === "shift" ? "shift" : "workday",
          aggregateBy: "PT1H"
        }
      }];
    }
    return channels;
  };
  _proto.getChartSeries = function getChartSeries(results) {
    var devices = this.getDevices();
    var metricChartSeries = this.props.metricChartSeries;
    var series = [];
    for (var i = 0; i < devices.length; i++) {
      var device = devices[i];
      var _loop = function _loop() {
        var _metricChartSeries$j = metricChartSeries[j],
          metricName = _metricChartSeries$j.metricName,
          seriesType = _metricChartSeries$j.seriesType;
        var key = device.uuid + ":" + metricName;
        var data = results[key];
        if (!data) {
          return 1; // continue
        }
        series.push({
          metricName: metricName,
          data: data,
          render: function render(props) {
            var SeriesComponent = getSeriesComponent(seriesType);
            return /*#__PURE__*/_react["default"].createElement(SeriesComponent, props);
          }
        });
      };
      for (var j = 0; j < metricChartSeries.length; j++) {
        if (_loop()) continue;
      }
    }
    return series;
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      _metricChartSeries = _this$props2.metricChartSeries,
      _devices = _this$props2.devices,
      _device = _this$props2.device,
      width = _this$props2.width,
      height = _this$props2.height,
      hideXAxis = _this$props2.hideXAxis,
      hideYAxis = _this$props2.hideYAxis,
      hideLabel = _this$props2.hideLabel,
      dataRange = _this$props2.dataRange,
      reportingPeriod = _this$props2.reportingPeriod,
      selection = _this$props2.selection,
      extra = _objectWithoutPropertiesLoose(_this$props2, _excluded);

    // Use the selection context interval if it's required
    var targetReportingInterval = dataRange === "SELECTION" && selection && selection.selected.reportingPeriod ? selection.selected.reportingPeriod.interval : reportingPeriod.interval;
    return /*#__PURE__*/_react["default"].createElement(_API.RealtimeBatchSubscription, {
      channels: this.getMetricChannels()
    }, function (results) {
      var data = _this2.getChartSeries(results);
      return /*#__PURE__*/_react["default"].createElement(_MetricChartContextMenu.MetricChartContextMenu, {
        data: data,
        width: width,
        height: height
      }, /*#__PURE__*/_react["default"].createElement(_Metrics2.MetricChart, _extends({
        width: width,
        height: height,
        showXAxis: !hideXAxis,
        showYAxis: !hideYAxis,
        yAxisWidth: hideLabel ? 35 : 65,
        showXUnits: false,
        showYUnits: !hideLabel,
        interval: targetReportingInterval
      }, (0, _getNonWidgetProps.getNonWidgetProps)(extra), {
        series: data
      })));
    });
  };
  return RealtimeMetricChartElement;
}(_react.Component), _RealtimeMetricChartElement.defaultProps = {
  reportingPeriod: undefined,
  device: undefined
}, _RealtimeMetricChartElement)) || _class) || _class) || _class) || _class);
function getSeriesComponent(input) {
  switch (input) {
    case "bar":
      return _Charts.BarChartSeries;
    case "area":
      return _Charts.AreaChartSeries;
    default:
      return _Charts.LineChartSeries;
  }
}